/// <summary>
/// Author: -
/// </summary>
export class ConfigEnum {
    static _LANGUAGE = "language";
    static _BEARER_TOKEN = "token";
    static _USER_DATA = "userData";
    static _SELECTED_CURRENCY = "selectedCurrency";
    static _CURRENCY_RATE = "currencyRate";
    static _SESSION_ID = 'sessionId';
}